import { useRouteLoaderData } from "~/utils/remix";

interface ProtectedLoaderData {
  identity?: {
    isImpersonating: boolean;
  };
}

export function useIsImpersonatedSession(): boolean {
  // The helper's generic return type cannot express that a route is absent on
  // public pages, so preserve the runtime undefined case at this boundary.
  const data = useRouteLoaderData<ProtectedLoaderData>("routes/_protected/_layout") as
    | ProtectedLoaderData
    | undefined;
  return data?.identity?.isImpersonating ?? false;
}
